export enum CasovyUsekTyp {
    'Vse',
    'Rok',
    'Mesic',
    'Den'
  }
